import styled from "styled-components";
import { COLORS } from "utils/constants";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  color: ${COLORS.TEXT};
`;
